<pm-dialog
  dialogTitle="RESULT_OVERVIEW.RE_EXECUTE.DIALOG.TITLE"
  contentClass="space-y-2"
  size="md"
  [secondaryCtaButtonConfig]="buttonConfigs().cancelConfig"
  [primaryCtaButtonConfig]="buttonConfigs().submitConfig"
>
  <!-- Configuration for Initial Forecast Version -->
  <pm-forecast-version-settings
    [forecastVersionSettingsFormGroup]="
      settingsForInitialForecastVersionFormGroup
    "
  />
</pm-dialog>
